__webpack_require__.p = "/~parthranawat/Nazila_Class_23/";